<template>
  <div style="margin: 20px">
    <el-button v-if="hasAddPermission" type="primary" @click="openSubmitDialog">办理申请</el-button>
    <h2 style="text-align: center">申请列表</h2>
    <el-table v-loading="loading" :data="handles" style="width: 100%; margin-top: 20px;">
      <el-table-column prop="type" label="需求类型" align="center"></el-table-column>
      <el-table-column prop="accountName" label="账号名称" align="center"></el-table-column>
      <el-table-column prop="applicant" label="申请人" align="center"></el-table-column>
      <el-table-column prop="isApproved" label="是否批准" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isApproved ? 'success' : 'info'">
            {{ scope.row.isApproved ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" width="180"></el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-button
              v-if="!scope.row.isApproved && hasAddPermission"
              type="primary"
              size="mini"
              @click="openApproveDialog(scope.row)">
            审核
          </el-button>
          <el-button
              v-if="hasAddPermission"
              size="mini"
              type="text"
              icon="el-icon-delete"
              @click="deleteSub(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 审核需求对话框 -->
    <el-dialog :visible.sync="approveDialogVisible" title="审核需求">
      <el-form :model="currentHandle" label-width="120px">
        <el-form-item label="需求类型">
          <el-input v-model="currentHandle.type" disabled></el-input>
        </el-form-item>
        <el-form-item label="账号名称">
          <el-input v-model="currentHandle.accountName" disabled></el-input>
        </el-form-item>
        <el-form-item label="申请人">
          <el-input v-model="currentHandle.applicant" disabled></el-input>
        </el-form-item>
        <el-form-item label="申请内容详情">
          <el-input type="textarea" v-model="currentHandle.detail" disabled></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="approveDialogVisible = false">取消</el-button>
        <el-button type="success" @click="approveRequest(1)">通过</el-button>
        <el-button type="danger" @click="approveRequest(0)">不通过</el-button>
      </div>
    </el-dialog>

    <!-- 提交需求对话框 -->
    <el-dialog :visible.sync="submitDialogVisible" :title="newHandle.type">
      <el-form :model="newHandle" label-width="120px" @submit.native.prevent>
        <el-form-item :label="item1">
          <el-input v-model="newHandle.accountName"></el-input>
        </el-form-item>
<!--        <el-form-item label="申请人">-->
<!--          <el-input v-model="newHandle.applicant"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item :label="item2">
          <el-input type="textarea" v-model="newHandle.detail"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitRequest">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="selectTypeDialogVisible" title="选择类型">
      <el-row :gutter="10" class="mb8">
        <el-col :span="1.5">
          <el-button
              type="primary"
              plain
              icon="el-icon-plus"
              size="mini"
              @click="handleAdd"
          >开设账号</el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button
              type="success"
              plain
              icon="el-icon-edit"
              size="mini"
              @click="handleUpdate"
          >账号更名</el-button>
        </el-col>
        <el-col :span="1.5">
          <el-button
              type="danger"
              plain
              icon="el-icon-delete"
              size="mini"
              @click="handleDelete"
          >账号注销</el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import request from "@/utils/request";
import {mapState} from "vuex";

export default {
  data() {
    return {
      loading: false,
      handles: [],
      approveDialogVisible: false,
      submitDialogVisible: false,
      selectTypeDialogVisible: false,
      currentHandle: {
        type: '',
        accountName: '',
        applicant: '',
        detail: ''
      },
      newHandle: {
        type: '',
        accountName: '',
        applicant: '',
        detail: ''
      },
      item1: '',
      item2: '',
      options: [{
        value: '选项1',
        label: '开设账号'
      }, {
        value: '选项2',
        label: '账号更名'
      }, {
        value: '选项3',
        label: '账号注销'
      }],
    };
  },
  mounted() {
    this.fetchRequests();
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    hasAddPermission() {
      // return this.user.funcKeys.includes('data_analysis_business_number_change_submit');
      return this.user.funcKeys.includes('data_analysis');
    },
    // hasDelPermission() {
    //   return this.user.funcKeys.includes('data_analysis_business_number_change_del');
    // },
    hasAuditPermission() {
      // return this.user.funcKeys.includes('data_analysis_business_number_change_audit');
      return this.user.funcKeys.includes('data_analysis');
    },
  },

  methods: {
    fetchRequests() {
      this.loading = true;
      axios.get('/api/handles/all')
          .then(response => {
            if (this.user.funcKeys.includes('admin')) {
              this.handles = response.data;
            } else {
              this.handles = response.data.filter(item => item.applicant === this.user.userName)
            }
            this.loading = false;
          })
          .catch(error => {
            console.error('获取需求列表失败', error);
            this.$message.error('获取需求列表失败');
          });
    },
    openApproveDialog(handle) {
      this.currentHandle = { ...handle };
      this.approveDialogVisible = true;
    },
    openSubmitDialog() {
      this.selectTypeDialogVisible = true;
    },
    handleAdd() {
      // console.log(this.user)
      this.newHandle.type = "开设账号"
      this.item1 = '账号名称'
      this.item2 = '账号介绍'
      this.submitDialogVisible = true
      this.newHandle.applicant = this.user.userName
    },
    handleUpdate() {
      this.newHandle.type = "账号更名"
      this.item1 = '原账号名称'
      this.item2 = '更名详情'
      this.submitDialogVisible = true
      this.newHandle.applicant = this.user.userName
    },
    handleDelete() {
      this.newHandle.type = "账号注销"
      this.item1 = '账号名称'
      this.item2 = '注销原因'
      this.submitDialogVisible = true
      this.newHandle.applicant = this.user.userName
    },
    submitRequest() {
      axios.post('/api/handles/submit', this.newHandle)
          .then(response => {
            this.$message.success('需求提交成功');
            this.submitDialogVisible = false;
            this.fetchRequests(); // 重新获取需求列表
          })
          .catch(error => {
            console.error('需求提交失败', error);
            this.$message.error('需求提交失败');
          });
    },
    approveRequest(isApproved) {
      const url = `/api/handles/approve/${this.currentHandle.id}`;
      axios.put(url, null, { params: { isApproved } })
          .then(response => {
            this.$message.success(isApproved ? '需求已批准' : '需求未批准');
            this.approveDialogVisible = false;
            this.fetchRequests(); // 重新获取需求列表
          })
          .catch(error => {
            console.error('审核需求失败', error);
            this.$message.error('审核需求失败');
          });
    },
    deleteSub(row){
      const id = row.id
      this.$confirm('是否确定删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.delete('/api/handles/del/' + id).then(res=>{
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.fetchRequests();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>
